import Vue from "vue";
import draggable from "vuedraggable";

Vue.component("Error", require("@/components/Error").default);
Vue.component("Draggable", draggable);
